<template>
  <van-overlay :show="$store.state.needConfirmClerkAgreement && $route.path !=='/article/detail'">
    <div class="wrapper" >
      <div class="box" @click.stop>
        <div class="formBox">
            <div class="title">店员协议</div>
          <div class="margin-lr-xs">
            <van-checkbox  v-model="clerkAgreementConfirm" class="margin-tb-sm"
                          icon-size="14px" style="font-size: 12px">
              我已阅读并同意
            </van-checkbox>
              <a style="color: #0CADF5" v-for="(agreement,index) in clerkAgreementList" :key="index"
                 @click.stop="$router.push(`/article/detail?id=${agreement.id}`)">《{{agreement.title}}》</a>
          </div>

        </div>
          <div  class="submit" @click="confirm">确定</div>

      </div>
    </div>
  </van-overlay>
</template>


<script>


import Vue from 'vue';
import {Checkbox, Dialog, Field, Toast, Overlay, CountDown} from 'vant';
import {handlePromise} from "@/libs/util";
import {confirmClerkAgreement, listClerkAgreement} from "@/api/clerk/agreement";

Vue.use(Checkbox)
    .use(Field)
    .use(Toast)
    .use(Overlay)
    .use(CountDown)
    .use(Dialog)

export default {
  name: "agreement-dialog",
  components: {
  },
  data(){
    return {
      clerkAgreementList: [],
      clerkAgreementConfirm: false,
    }
  },
  watch:{
    '$store.state.needConfirmClerkAgreement'(val){
      if(val){
        Toast.loading()
      handlePromise(listClerkAgreement(), (data) => {
        this.clerkAgreementList = data.agreementList
      },null,()=>{
        Toast.clear()
      })
      }
    }
  },
  computed:{
  },
  methods: {
    confirm(){
      // 没有同意协议
      if(!this.clerkAgreementConfirm){
        Toast('请阅读并同意协议')
        return;
      }
      Toast.loading({
        mask: true,
        message: '请稍候'
      })
      handlePromise(confirmClerkAgreement(this.clerkAgreementList.map(item=>item.id)),()=>{
        this.$store.commit('setNeedConfirmClerkAgreement', false)
        Toast.clear()
      })

    },
  },
  mounted() {
  }
}
</script>

<style lang="less" scoped>
.van-overlay{
  z-index: 2002;
}

.formBox {
  margin: 0 10px 10px;
  background: #fff;
  border-radius: 10px;

  .note {
    font-size: 12px;
    margin: 15px;
  }

  .title {
    font-size: 18px;
    margin: 0 16px;
    padding: 10px 0;
    position: relative;
    text-align: center;

    &::after{
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      border-bottom: 1px solid #ebedf0;
      transform: scaleY(.5);
    }
  }
  /deep/.default{
    display: -webkit-box !important;
    padding: 10px 0 !important;
    &::after{
      content: none;
    }
    .van-cell__title.van-field__label{
      font-weight: normal;
      font-size: 14px;
      color: #646566;
      margin-right: 12px;
      width: 6.2em;
    }
    .van-cell__value.van-field__value{
      left: unset;
      margin: unset;
      .van-field__control{
        border: 0;
        background: #f5f5f5;
        border-radius: 6px;
        padding: 5px;
        height: 40px;
        font-size: 16px;
        color: #323233;
        &::placeholder{
          color: #c8c9d2 !important;
        }
      }
    }

  }

  .agreement{
    padding: 10px 16px;

    .text{
      margin-left: 5px;
      color: blue;
    }
  }
}

.submit {
  width: 80%;
  margin: 15px auto 0;
  color: #fff;
  text-align: center;
  padding: 10px;
  border-radius: 999px;
  background: var(--primary-color);
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  .box{
    padding: 10px 0 15px;
    margin: 0 25px;
    background: #fff;
    border-radius: 8px;
    min-width: 88%;
  }
}

/deep/.van-field__label{
  width: 4.2em;
}

.mobileField{
  /deep/.van-field__control{
    border: none;
  }
  background: #e7e6e6;
  border-radius: 999px;
  margin: 5px 0;
}

/deep/ input::placeholder {
  color: #999999 !important;
}
.send-code{
  color: #808080;
  font-size: 13px;
}
</style>
